var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-wrapper" },
    [
      _vm.showbottomkefu
        ? _c(
            "div",
            { staticClass: "fixed-kefu", on: { click: _vm.goZhichi } },
            [
              _c("img", {
                staticClass: "zhichi-img",
                attrs: { src: require("../../../static/images/zhichi.png") }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.strongtip
        ? _c("div", { staticClass: "config_mask" }, [
            _c("div", { staticClass: "config_content" }, [
              _c("p", { staticClass: "config_title" }, [
                _vm.isweixin
                  ? _c("img", {
                      attrs: {
                        src: require("../../../static/images/guanbi.png")
                      },
                      on: {
                        click: function($event) {
                          _vm.strongtip = false
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "config_detail" },
                _vm._l(_vm.strongwxlist, function(i) {
                  return _c("div", { staticClass: "out_loop" }, [
                    _vm.isweixin
                      ? _c("p", { staticClass: "warn_mes" }, [
                          _vm._v(_vm._s(i.remark))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "weixin_img" }, [
                      _c("img", {
                        staticClass: "img_link",
                        attrs: { src: i.qr }
                      }),
                      _vm._v(" "),
                      _vm.isweixin
                        ? _c("img", {
                            staticClass: "hand",
                            attrs: {
                              src: require("../../../static/images/hand.png")
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.isweixin
                      ? _c("p", { staticClass: "wenan" }, [
                          _vm._v("微信扫码 邀你进群")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isweixin
                      ? _c(
                          "div",
                          {
                            staticClass: "go_wxapp_btn",
                            on: {
                              click: function($event) {
                                return _vm.goWxapp(i.qr)
                              }
                            }
                          },
                          [_vm._v(_vm._s(i.buttonName || "点击添加微信"))]
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.strongtip && _vm.isMember
        ? _c("div", { staticClass: "member-wrapper" }, [
            _c("div", { staticClass: "member-content" }, [
              _c("p", { staticClass: "kf_title" }, [
                _vm._v("微信客服"),
                _c("img", {
                  attrs: { src: require("../../../static/images/cancel.png") },
                  on: {
                    click: function($event) {
                      _vm.isMember = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("img", {
                staticClass: "member_img",
                attrs: { src: _vm.wxQrcode }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("使用微信扫码添加")])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isapplets
        ? _c("div", { staticClass: "header" }, [
            _vm.dataList.isGiveCourse == 1
              ? _c(
                  "span",
                  {
                    staticClass: "give",
                    on: {
                      click: function($event) {
                        _vm.isshare = true
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: require("../../../static/images/give.png") }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.istitle
              ? _c("p", { staticClass: "top_title" }, [
                  _vm._v(_vm._s(_vm.dataList.order_name))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dataList
        ? _c(
            "section",
            [
              _c("div", { staticClass: "live_options" }, [
                _c("div", { staticClass: "swiper-container" }, [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.calendarList, function(i, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "swiper-slide",
                          on: {
                            click: function($event) {
                              return _vm.go_zhibo(i)
                            }
                          }
                        },
                        [
                          _c("p", [
                            new Date().getTime() < (i.start_time - 600) * 1000
                              ? _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/jijiangkaishi.png")
                                  }
                                })
                              : new Date().getTime() >
                                (i.end_time - 0 + 600) * 1000
                              ? _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/yijieshu.png")
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/zhibozhong.png")
                                  }
                                }),
                            _vm._v(" "),
                            _c("span", { staticClass: "livetipname" }, [
                              _vm._v(
                                _vm._s(i.lesson_name) + _vm._s(i.package_name)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "poster",
                            attrs: {
                              src: require("../../../static/images/default.png")
                            }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "swiper-pagination" })
                ])
              ]),
              _vm._v(" "),
              _vm.calendarList.length == 0
                ? _c("div", [
                    _vm.dataList.picture
                      ? _c("div", { staticClass: "banner" }, [
                          _c("img", { attrs: { src: _vm.dataList.picture } })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "title-box" }, [
                _vm.again
                  ? _c(
                      "span",
                      {
                        staticClass: "buy_again",
                        on: { click: _vm.back_shop }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.dataList.allowRepeatText || "再次购买")
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "title", on: { click: _vm.back_shop } },
                  [_vm._v(_vm._s(_vm.dataList.order_name))]
                ),
                _vm._v(" "),
                _vm.dataList.leaf == 1
                  ? _c("div", { staticClass: "online_time" }, [
                      _vm.level_count
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.level_count) + "个课件")
                          ])
                        : _vm._e(),
                      _vm.hour
                        ? _c("span", [
                            _vm._v(" | " + _vm._s(_vm.hour) + "个课时")
                          ])
                        : _vm._e(),
                      _vm.online_time
                        ? _c("span", [_vm._v(" | " + _vm._s(_vm.online_time))])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "goumai_time" }, [
                  _vm._v("购买时间：" + _vm._s(_vm.dataList.createdAt)),
                  _vm.changeshop
                    ? _c(
                        "span",
                        {
                          staticClass: "qihuan_time",
                          on: { click: _vm.change }
                        },
                        [
                          _vm._v("切换"),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/images/change.png")
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.dataList.open_course_remark
                  ? _c(
                      "div",
                      { class: [{ show: !_vm.isShow }, "opening-time"] },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.dataList.open_course_remark) +
                            "\n        "
                        ),
                        _vm.dataList.open_course_remark &&
                        _vm.dataList.open_course_remark.length > 60
                          ? _c(
                              "span",
                              {
                                staticClass: "text_overflow",
                                on: { click: _vm.show }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.isShow == true ? "收起" : "展开")
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.isShow
                                  ? _c("van-icon", {
                                      attrs: {
                                        name: "arrow-down",
                                        color: "#999"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isShow
                                  ? _c("van-icon", {
                                      attrs: { name: "arrow-up", color: "#999" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("liveTip", {
                attrs: {
                  config: _vm.configList,
                  isLiveTip: _vm.isLiveTip,
                  remind: _vm.remind,
                  msg_introduce: _vm.introduce
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "tab_margin" }),
              _vm._v(" "),
              _c("div", { ref: "obtain", staticClass: "tab-box" }, [
                _vm.isapplets
                  ? _c(
                      "div",
                      { staticClass: "tabs", class: { fixed: _vm.isfixed } },
                      _vm._l(_vm.tabList, function(item, index) {
                        return _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.show,
                                expression: "item.show"
                              }
                            ],
                            key: index,
                            class: { active: _vm.currentIndex == index },
                            on: {
                              click: function($event) {
                                return _vm.changeIndex(index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.value))]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "tabs", class: { fixeds: _vm.isfixed } },
                      _vm._l(_vm.tabList, function(item, index) {
                        return _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.show,
                                expression: "item.show"
                              }
                            ],
                            key: index,
                            class: { active: _vm.currentIndex == index },
                            on: {
                              click: function($event) {
                                return _vm.changeIndex(index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.value))]
                        )
                      }),
                      0
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _vm.currentIndex == 0
                      ? _c("addGroup", {
                          attrs: {
                            config: _vm.configList,
                            isLiveTip: _vm.isLiveTip,
                            remind: _vm.remind,
                            msg_introduce: _vm.introduce
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentIndex == 0 && _vm.dataList.leaf == 0
                      ? _c("onlineCourse", {
                          attrs: {
                            dataList: _vm.dataList.list,
                            currentIndex: _vm.currentIndex
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentIndex == 0 && _vm.dataList.leaf == 1
                      ? _c("leaf", { attrs: { dataList: _vm.dataList.list } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentIndex == 1
                      ? _c("courseInfo", {
                          attrs: { dataList: _vm.dataList.courseIntroduction }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentIndex == 2
                      ? _c("coursePackage", {
                          attrs: {
                            config: _vm.configList,
                            strongtip: _vm.strongtip,
                            strongwxlist: _vm.strongwxlist
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentIndex == 3
                      ? _c("moreCourses", {
                          attrs: {
                            currentIndex: _vm.currentIndex,
                            numberGoodsId: _vm.numberGoodsId
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataList.goodsId != "wp0152111231528081001" && !_vm.hideFooter
        ? _c("div", [
            _vm.show_flag && !_vm.isShowFlag && !_vm.isapplets
              ? _c("div", { staticClass: "footer" }, [
                  _c("span", { staticClass: "bottom_text" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/bottom.png")
                      },
                      on: { click: _vm.close_bottom }
                    }),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      { staticClass: "footer_btns", on: { click: _vm.opentk } },
                      [_vm._v("打开APP")]
                    )
                  ])
                ])
              : _vm.show_flag && !_vm.isShowFlag && _vm.android && _vm.isapplets
              ? _c("div", { staticClass: "footer" }, [
                  _c("span", { staticClass: "bottom_text" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/bottom.png")
                      },
                      on: { click: _vm.close_bottom }
                    }),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm.sf != "zgyc" && _vm.sf != "zgjsgc"
                      ? _c(
                          "a",
                          {
                            staticClass: "footer_btns",
                            attrs: {
                              href:
                                _vm.scheme +
                                "?type=1&sso_id=" +
                                _vm.sso_id +
                                "&orderSn=" +
                                _vm.sn +
                                "&spuID=" +
                                _vm.dataList.goodsId +
                                "&owner=" +
                                this.$route.query.owner +
                                "&channel=" +
                                this.$route.query.channel +
                                "&orgn=" +
                                this.$route.query.orgn
                            },
                            on: { click: _vm.search_flag }
                          },
                          [_vm._v("打开APP")]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "footer_btns",
                            attrs: { href: _vm.open_url }
                          },
                          [_vm._v("打开APP")]
                        )
                  ])
                ])
              : _vm.show_flag && !_vm.isShowFlag && _vm.ios && _vm.isapplets
              ? _c("div", { staticClass: "footer" }, [
                  _c("span", { staticClass: "bottom_text" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/bottom.png")
                      },
                      on: { click: _vm.close_bottom }
                    }),
                    _vm._v(" "),
                    _vm._m(3)
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "footer_btns",
                        on: { click: _vm.search_flag }
                      },
                      [_vm._v("打开APP")]
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { data: _vm.detail, type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.option
        ? _c("div", { staticClass: "buyshop_time" }, [
            _c(
              "div",
              { staticClass: "mask_content" },
              [
                _c("van-picker", {
                  staticClass: "time_picker",
                  attrs: {
                    title: "购买时间",
                    columns: _vm.columns,
                    "default-index": _vm.defa_flag,
                    "show-toolbar": ""
                  },
                  on: { cancel: _vm.onCancel, confirm: _vm.onChange }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + 'APP"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=1&sso_id=" +
                              _vm.sso_id +
                              "&orderSn=" +
                              _vm.sn +
                              "&spuID=" +
                              _vm.goodsId +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e(),
      _vm._v(" "),
      _vm.isshare
        ? _c("share", {
            attrs: { detailobj: _vm.detailobj },
            on: { share: _vm.accept }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAi ? _c("div", { staticClass: "BootDownload_bg" }) : _vm._e(),
      _vm._v(" "),
      _vm.isAi
        ? _c(
            "div",
            { staticClass: "BootDownload", class: _vm.isClass ? "wxapp" : "" },
            [
              _c("div", { staticClass: "close", on: { click: _vm.aiclose } }),
              _vm._v(" "),
              _c("div", {
                staticClass: "h1",
                domProps: { innerHTML: _vm._s(_vm.BootDownloadV1) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.subTitle))]),
              _vm._v(" "),
              _vm.isClass
                ? _c(
                    "div",
                    { staticClass: "v3" },
                    _vm._l(_vm.methods, function(item, index) {
                      return _c("div", [_vm._v(_vm._s(item))])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isClass
                ? _c("div", { staticClass: "ewm" }, [
                    _c("img", { attrs: { src: _vm.download_image } })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "copy", on: { click: _vm.openAI } }, [
                _vm._v(_vm._s(_vm.butName))
              ]),
              _vm._v(" "),
              _c("textarea", {
                staticStyle: { display: "none" },
                attrs: { id: "textArea" }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "kf_content" }, [
      _vm._v("务必添加专属客户经理，"),
      _c("br"),
      _vm._v("以保证享受会员服务")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("使用APP听课更流畅，更高效的用户体验"),
      _c("br"),
      _vm._v("点击按钮升级到APP最新版本,尽享更多惊喜!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("使用APP听课更流畅，更高效的用户体验"),
      _c("br"),
      _vm._v("点击按钮升级到APP最新版本,尽享更多惊喜!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("使用APP听课更流畅，更高效的用户体验"),
      _c("br"),
      _vm._v("点击按钮升级到APP最新版本,尽享更多惊喜!")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a4dad84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a4dad84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/detail.vue
// module id = null
// module chunks = 